// API Configuration
export const API_CONFIG = {
  baseUrl: "https://ai.riple.org",
  timeouts: {
    standard: 180000, // 3 minutes
    deepAnalysis: 600000, // 10 minutes
    deepDive: 900000, // 15 minutes
    deeperDive: 1200000, // 20 minutes
    thinkingMode: 300000, // 5 minutes
  },
};

// File Configuration
export const FILE_CONFIG = {
  maxFiles: 10,
  maxFileSize: 20 * 1024 * 1024, // 20MB
  allowedTypes: [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    "image/webp",
    "application/pdf",
  ],
};

// Analysis Modes
export const ANALYSIS_MODES = {
  STANDARD: "standard",
  THINKING_MODE: "thinking_mode",
  DEEP_ANALYSIS: "deep_analysis",
  DEEP_DIVE: "deep_dive",
  DEEPER_DIVE: "deeper_dive",
};
